import { render, staticRenderFns } from "./evaluacion-jefedepartamento.vue?vue&type=template&id=2fb34bea"
import script from "./evaluacion-jefedepartamento.vue?vue&type=script&lang=js"
export * from "./evaluacion-jefedepartamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports